/* eslint-disable import/no-dynamic-require, global-require */

const {getCookiesNames} = require('./cookie');

const PARSE_ERRORS = {
  country: 'country',
  lang: 'lang',
  locale: 'locale'
};

const defaultLocale = 'en_XX';

const defaultLang = defaultLocale.substring(0, 2);
const defaultCountry = defaultLocale.substring(3, 5);

const acceptLangs = [
  'ar',
  'bg',
  'cs',
  'de',
  'en',
  'es',
  'fr',
  'he',
  'hu',
  'it',
  'ja',
  'ko',
  'pl',
  'pt',
  'ro',
  'ru',
  'th',
  'tr',
  'vi',
  'zh'
];

/*
 *  Keys should be from 'acceptLangs'
 *  Each lang should have at least one country
 */
const acceptCountries = {
  zh: ['cn', 'tw']
};

const langsWithLimitedCountries = Object.keys(acceptCountries);

langsWithLimitedCountries.forEach(lang => {
  if (!acceptLangs.includes(lang)) {
    throw new Error(`Lang '${lang}' is not from accepted langs`);
  }

  if (acceptCountries[lang].length < 1) {
    throw new Error(`Lang '${lang}' with limited countries has no fallback country`);
  }
});

const acceptLangsRegexp = new RegExp(acceptLangs.reduce((prev, locale) => `${prev}|${locale}`));

const defaultResult = {
  lang: defaultLang,
  country: defaultCountry,
  translation: defaultLang,
  locale: defaultLocale
};

const parseLocale = (value, error_cb = () => {}) => {
  if (value && value.length === 5) {
    const lang = value.substring(0, 2).toLowerCase();

    if (langsWithLimitedCountries.includes(lang)) {
      const country = value.substring(3, 5).toLowerCase();
      const acceptCountry = acceptCountries[lang].includes(country);
      const upperCasedCountry = country.toUpperCase();

      if (!acceptCountry) error_cb(PARSE_ERRORS.country, value);

      return {
        lang,
        country: upperCasedCountry,
        translation: acceptCountry ? country : acceptCountries[lang][0],
        locale: value,
        isValidationPassed: acceptCountry
      };
    }

    if (acceptLangs.includes(lang)) {
      return {
        lang,
        country: value.substring(3, 5).toUpperCase(),
        translation: lang,
        locale: value,
        isValidationPassed: true
      };
    }

    error_cb(PARSE_ERRORS.locale, value);

    return {
      ...defaultResult,
      isValidationPassed: false
    };
  }

  return {
    ...defaultResult,
    isValidationPassed: value === void 0
  };
};

const defaultLabels = require(`./translations/${defaultResult.translation}.json`);

const hasLabel = label => defaultLabels[label];

const getAppLocale = (locale, projectId, cookies) => {
  const cookiesNames = getCookiesNames(projectId);

  return parseLocale(locale || cookies[cookiesNames.locale] || defaultLocale);
};

/**
 * Loads labels for passed language
 * @param {string} lang - 2-letter lang code that represents file from /common/translations
 * @param {function(string):Object} loader - additional loader that takes lang as param
 * @returns {Object} - label-text map
 */
const getTranslationsData = (lang, loader = () => {}) => {
  try {
    return {
      ...defaultLabels,
      ...require(`./translations/${lang}.json`),
      ...loader(lang)
    };
  } catch (e) {
    return {
      ...defaultLabels,
      ...loader(defaultLang)
    };
  }
};

module.exports = {
  acceptLangs,
  acceptCountries,
  acceptLangsRegexp,
  parseLocale,
  defaultLang,
  defaultLocale,
  defaultLabels,
  getAppLocale,
  getTranslationsData,
  hasLabel,
  PARSE_ERRORS,
  langsWithLimitedCountries
};



// WEBPACK FOOTER //
// ../common/localization.js